import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { errMsg } from '../helper/functions';
import { errMsgNoData } from '../helper/functions';
import { ErrorResponseType } from '../types';

const getTechnologyCategoriesCode = import.meta.env.VITE_GET_TECH_CATEGORY_CODE;

export const getTechnologyCategories = async () => {
  const ret: {
    data: GetTechnologyCategoriesType[] | null;
    error: ErrorResponseType | null;
  } = {
    data: null,
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.technologyCategories}?code=${getTechnologyCategoriesCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface GetTechnologyCategoriesType {
  id: number;
  name: string;
}

const getTechnologiesByCategoryCode = import.meta.env
  .VITE_GET_TECHS_BY_CATEGORY_CODE;

export const getTechnologiesByCategory = async (id: number) => {
  const ret: {
    data: TechnologyCategory[] | null;
    error: ErrorResponseType | null;
  } = {
    data: null,
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.technologiesByCategory}/${id}?code=${getTechnologiesByCategoryCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface TechnologyCategory {
  id: string;
  classificationId: number;
  name: string;
  classification: {
    id: number;
    name: string;
  };
}

interface AddNewTechSkillRequestType {
  ClassificationId: number;
  Name: string;
}

const addNewTechSkillCode = import.meta.env.VITE_ADD_NEW_TECH_SKILL_CODE;

export const addNewTechSkill = async (reqData: AddNewTechSkillRequestType) => {
  const ret: {
    data: TechnologyCategory[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.techSkill}?code=${addNewTechSkillCode}`,
      reqData
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface AddUpdateUserTechSkillReqType {
  UserId: string;
  SkillId: string;
  Rating: number;
  NumOfProjects: number;
  Experience: number;
}

const addUpdateUserTechSkillCode = import.meta.env
  .VITE_ADD_UPDATE_USER_TECH_SKILL_CODE;

export const addUpdateUserTechSkill = async (
  reqData: AddUpdateUserTechSkillReqType[]
) => {
  const ret: {
    data: UserTechSkillResponseType[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.userTechSkill}?code=${addUpdateUserTechSkillCode}`,
      reqData
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

const getAllUserTechSkillsCode = import.meta.env.VITE_GET_All_USER_SKILLS_CODE;

export const getAllUserTechSkills = async (userId: string) => {
  const ret: {
    data: UserTechSkillResponseType[] | null;
    error: ErrorResponseType | null;
  } = {
    data: null,
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.userSkills}/${userId}?code=${getAllUserTechSkillsCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface UserTechSkillResponseType {
  id: string;
  skillId: string;
  userId: string;
  rating: number;
  numOfProjects: number;
  experience: number;
  techSkill: {
    id: string;
    classificationId: number;
    name: string;
    classification: {
      id: number;
      name: string;
    };
  };
}

const getAllUserInterestsCode = import.meta.env
  .VITE_GET_All_USER_INTERESTS_CODE;

export const getAllUserInterests = async (userId: string) => {
  const ret: {
    data: UserInterestType[] | null;
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.userInterests}/${userId}?code=${getAllUserInterestsCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface UserInterestType {
  id: string;
  userId: string;
  interests: string;
  overallExperience: number | null;
  user: any | null;
}

interface AddUpdateUserInterestsReqType {
  UserId: string;
  Interest: string;
}

const addUpdateUserInterestsCode = import.meta.env
  .VITE_ADD_UPDATE_USER_INTERESTS_CODE;

export const addUpdateUserInterests = async (
  reqData: AddUpdateUserInterestsReqType[]
) => {
  const ret: {
    data: UserInterestType[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.userInterests}?code=${addUpdateUserInterestsCode}`,
      reqData
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

const getAllDomainsCode = import.meta.env.VITE_GET_ALL_DOMAINS_CODE;

export const getAllDomains = async () => {
  const ret: {
    data: GetAllDomains[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.skillDomains}?code=${getAllDomainsCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

const getAllUserDomainsCode = import.meta.env.VITE_GET_ALL_USER_DOMAINS_CODE;

export const getAllUserDomains = async (userId: string) => {
  const ret: {
    data: GetAllUserDomainsResType[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.userSkillDomains}/${userId}?code=${getAllUserDomainsCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface GetAllUserDomainsResType {
  id: string;
  userId: string;
  domainId: number;
  rating: number;
  domain: {
    id: number;
    name: string;
  };
  user: any | null;
}

export interface GetAllDomains {
  id: number;
  name: string;
}

export interface AddUpdateUserSkillDomainReqType {
  UserId: string;
  DomainId: number;
  Rating: number;
}

const addUpdateUserSkillDomainCode = import.meta.env
  .VITE_ADD_UPDATE_USER_SKILL_DOMAINS_CODE;

export const addUpdateUserSkillDomain = async (
  reqData: AddUpdateUserSkillDomainReqType[]
) => {
  const ret: {
    data: GetAllUserDomainsResType[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.userSkillDomain}?code=${addUpdateUserSkillDomainCode}`,
      reqData
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

const getAllCertificationCategoriesCode = import.meta.env
  .VITE_GET_ALL_CERTIFICATION_CATEGORIES_CODE;

export const getAllCertificationCategories = async () => {
  const ret: {
    data: GetAllCertificationCategoriesResType[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.certificationCategories}?code=${getAllCertificationCategoriesCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface GetAllCertificationCategoriesResType {
  id: number;
  name: string;
}

const getCertificationByCategoryCode = import.meta.env
  .VITE_GET_CERTIFICATION_BY_CATEGORY_CODE;

export const getCertificationByCategory = async (id: number) => {
  const ret: {
    data: GetCertificationByCategoryResType[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.certificationsByCategory}/${id}?code=${getCertificationByCategoryCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface GetCertificationByCategoryResType {
  id: number;
  name: string;
  categoryId: number;
  certificationCategory: any | null;
}

const getUserCertificationsCode = import.meta.env
  .VITE_GET_USER_CERTIFICATIONS_CODE;

export const getUserCertifications = async (userId: string) => {
  const ret: {
    data: GetUserCertificationsResType[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.userCertifications}/${userId}?code=${getUserCertificationsCode}`
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export interface GetUserCertificationsResType {
  id: string;
  userId: string;
  certificationId: number;
  certification: {
    id: number;
    name: string;
    categoryId: number;
    certificationCategory: {
      id: number;
      name: string;
    };
  };
}

export interface AddUpdateUserCertificationsReqType {
  UserId: string;
  CertificationId: number;
}

const addUpdateUserCertificationCode = import.meta.env
  .VITE_ADD_UPDATE_USER_CERTIFICATION_CODE;

export const addUpdateUserCertifications = async (
  reqData: AddUpdateUserCertificationsReqType[]
) => {
  const ret: {
    data: GetUserCertificationsResType[];
    error: ErrorResponseType | null;
  } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.userCertification}?code=${addUpdateUserCertificationCode}`,
      reqData
    );
    if (data) {
      ret.data = data;
    } else {
      ret.error = errMsgNoData();
    }
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};
